var plPL = {
  locale: 'pl_PL',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'YYYY-WW',
      date: 'YYYY-MM-DD',
      month: 'YYYY-MM',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'YYYY-MM-DD HH:mm:ss'
    },
    startDay: 0,
    monthList: ['styczeń', 'luty', 'marsz', 'kwietnia', 'może', 'June', 'lipiec', 'sierpień', 'września', 'Październik', 'listopad', 'grudzień'],
    shortMonthList: ['styczeń', 'luty', 'marsz', 'kwietnia', 'może', 'June', 'lipiec', 'sierpień', 'września', 'Październik', 'listopad', 'grudzień'],
    dayList: ['niedziela', 'poniedziałek', 'wtorek', 'Środa', 'czwartek', 'Piątek', 'sobota'],
    shortDayList: ['niedziela', 'poniedziałek', 'wtorek', 'Środa', 'czwartek', 'Piątek', 'sobota'],
    shortestDayList: ['dzień', 'jeden', 'dwa', 'trzy', 'cztery', 'pięć', 'sześć']
  },
  'dynamic-date': {
    day: 'dzień',
    week: 'tydzień',
    month: 'miesiąc',
    quarter: 'kwartał',
    year: 'rok',
    before: 'Przed ${value}${unit}'
  },
  'auto-complete.placeholder': 'Proszę wybrać',
  'auto-complete.empty': 'Brak danych',
  'cascader.titles': ['poziom 1', 'poziom 2', 'Poziom 3', 'poziom 4', 'pięć poziomów', 'sześć poziomów', 'Siedem poziomów', 'poziom 8'],
  'cascader.empty': 'Brak danych',
  'cascader.search': 'Proszę wprowadzić wyszukiwane terminy',
  'color.custom': 'Kolor niestandardowy',
  'date.year': '${year}rok',
  'date.month': 'miesiąc',
  'date.week': 'tydzień',
  'date.month-first': false,
  'date-picker.start': 'czas rozpoczęcia',
  'date-picker.end': 'Czas zakończenia',
  'date-picker.placeholder': 'Proszę wybrać datę',
  'date-picker.cancel': 'anuluj',
  'date-picker.apply': 'aplikacja',
  'date-picker.invalid-range': 'Wybrany zakres czasu przekroczył opcjonalny zakres, proszę dostosować',
  'date-comparison.mom': 'W porównaniu z poprzednim okresem',
  'date-comparison.yoy': 'Ten okres w zeszłym roku',
  'date-comparison.placeholder': 'czas rozpoczęcia ~ Czas zakończenia',
  'date-comparison.error-source': 'Proszę wybrać czas rozpoczęcia porównania',
  'date-comparison.error-target': 'Proszę wybrać czas końca porównania',
  'date-comparison.compare': 'kontrast',
  'date-comparison.compare-text': 'kontrast',
  'dynamic-date.customize': 'niestandardowe',
  'dynamic-date.date-preview': 'Podgląd czasu',
  'dynamic-date.dynamic-date': 'Czas dynamiczny',
  'dynamic-date.interval': 'Jednostka czasowa',
  'dynamic-date.fixed-date': 'Czas stały',
  'empty.text': 'Brak danych',
  'input.placeholder': 'Proszę wprowadzić',
  'textarea.placeholder': 'Proszę wprowadzić',
  'list-viewer.empty': 'Brak danych',
  'modal.cancel': 'anuluj',
  'modal.ok': 'określić',
  'pager.jump': 'Skacz',
  'pager.total': '${total} rekordy łącznie',
  'pager.size': '${count}wpisy/strona',
  'pager.page.placeholder': 'Proszę wprowadzić',
  'popover.cancel': 'anuluj',
  'popover.ok': 'określić',
  'schedule.selected': 'Wybrany czas',
  'schedule.clear': 'pusty',
  'schedule.separator': '、',
  'schedule.title': 'data/czas',
  'select.search.placeholder': 'Proszę wprowadzić',
  'select.empty': 'Brak danych',
  'select.selected': 'Wybrane',
  'select.selected-count': 'Wybrana pozycja${count}',
  'select.select-all': 'Zaznacz wszystkie',
  'select.placeholder': 'Proszę wybrać',
  'select.clear': 'pusty',
  'tabs.more': 'więcej',
  'table.emptyText': 'Zawartość jest pusta',
  'table.filter.reset': 'Resetuj',
  'table.filter.confirm': 'określić',
  'transfer.empty': 'Brak istotnych danych',
  'transfer.placeholder': 'Proszę wprowadzić',
  'transfer.source': 'Lista źródłowa',
  'transfer.target': 'Lista docelowa',
  'tree.empty': 'Brak wyników',
  'tree-select.placeholder': 'Proszę wprowadzić',
  'tree-select.empty': 'Brak danych',
  'time-picker.placeholder': 'Proszę wybrać godzinę',
  'time-range-picker.placeholder': 'czas rozpoczęcia ~ Czas zakończenia',
  'upload.error.overflow-count': 'Maksymalna liczba plików przekroczona',
  'upload.click': 'Kliknij na przesłanie',
  'upload.drop': 'Przeciągnij plik tutaj, lub',
  'date-time-picker.now': 'w tej chwili',
  'date-time-picker.ok': 'określić',
  'date-time-picker.date': 'Wybierz datę',
  'date-time-picker.time': 'Wybierz czas',
  'date-time-picker.placeholder': 'Proszę wprowadzić',
  'date-time-picker.start': 'Wybierz datę rozpoczęcia',
  'date-time-picker.end': 'Wybierz datę końcową',
  'date-time-picker-panel.start': 'Data rozpoczęcia',
  'date-time-picker-panel.end': 'Data końcowa',
  'image-view.next': 'Następny',
  'image-view.prev': 'Poprzednie',
  'image-view.zoom-in': 'powiększyć',
  'image-view.zoom-out': 'wąskie',
  'image-view.zoom-to-origin': 'Oryginalny rozmiar',
  'image-view.zoom-to-fit': 'Dostosowanie',
  'image-view.rotate': 'obracać',
  table: {
    selectionMenu: {
      selectCurrent: 'Select Current',
      selectAll: 'Select All',
      unselectCurrent: 'Unselect Current',
      unselectAll: 'Unselect All'
    }
  }
};
export default plPL;